const makeBorderRadius = (borderRadius, isSharpLeftSide, isSharpRightSide, isSharpTopSide, isSharpBottomSide) => {
    return {
        borderTopLeftRadius: isSharpLeftSide || isSharpTopSide ? 0 : borderRadius.surface.medium,
        borderTopRightRadius: isSharpRightSide || isSharpTopSide ? 0 : borderRadius.surface.medium,
        borderBottomLeftRadius: isSharpLeftSide || isSharpBottomSide ? 0 : borderRadius.surface.medium,
        borderBottomRightRadius: isSharpRightSide || isSharpBottomSide ? 0 : borderRadius.surface.medium,
    };
};
export default makeBorderRadius;
